/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 134);
/******/ })
/************************************************************************/
/******/ ({

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// @ts-nocheck
/* global require */
window.Quantumart = window.Quantumart || {};
window.Quantumart.QP8 = window.Quantumart.QP8 || {};
__webpack_require__(34);


/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BackendLogin", function() { return BackendLogin; });
var BackendLogin = /** @class */ (function () {
    function BackendLogin(options) {
        this.storageKey = BackendLogin.storageKey;
        this._useSavedCustomerCode = false;
        this.removeCustomerCode = BackendLogin.removeCustomerCode;
        if (options) {
            if (options.useSavedCustomerCode) {
                this._useSavedCustomerCode = options.useSavedCustomerCode;
            }
        }
        jQuery(document).ready(jQuery.proxy(this._initialize, this));
    }
    BackendLogin.prototype._initialize = function () {
        if (this._useSavedCustomerCode) {
            var notValid = jQuery('.validation-summary-errors').length > 0;
            if (notValid) {
                this.removeCustomerCode();
            }
            else {
                var value = localStorage.getItem(this.storageKey);
                var isIntegratedLogin = jQuery('#UserName').length === 0;
                if (isIntegratedLogin) {
                    if (value) {
                        jQuery('#CustomerCode').val(value);
                        jQuery('form').submit();
                    }
                    else {
                        jQuery('#Login').click(jQuery.proxy(this._loginClick, this));
                    }
                }
            }
        }
    };
    BackendLogin.prototype._loginClick = function () {
        localStorage.setItem(this.storageKey, jQuery('#CustomerCode').val());
    };
    return BackendLogin;
}());

BackendLogin.storageKey = 'Quantumart.QP8.BackendLogin.CustomerCode';
BackendLogin.removeCustomerCode = function () {
    localStorage.removeItem(BackendLogin.storageKey);
};
Quantumart.QP8.BackendLogin = BackendLogin;


/***/ })

/******/ });


// WEBPACK FOOTER //
// app-logon.js